import { computed } from 'vue'
import { useLocale } from './useLocale.js'

// App locale → BCP47 tag for native Intl formatting. Chosen over vue-i18n
// d()/n(): existing call sites already pass Intl option objects inline, native
// Intl needs zero per-locale config, and this works outside components too.
// App 2-letter locale → BCP47 tag for native Intl. European variants chosen for
// es/pt (es-ES Castilian, pt-PT European Portuguese). Entries are inert until
// the locale is in SUPPORTED_LOCALES; unknown locales fall back to en-US.
const BCP47 = { en: 'en-US', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', pt: 'pt-PT', it: 'it-IT' }

export function useLocaleFormat() {
  const { currentLocale } = useLocale()
  const localeTag = computed(() => BCP47[currentLocale.value] || 'en-US')

  const formatDate = (date, options) => new Date(date).toLocaleDateString(localeTag.value, options)
  const formatDateTime = (date, options) => new Date(date).toLocaleString(localeTag.value, options)
  const formatNumber = (value, options) => new Intl.NumberFormat(localeTag.value, options).format(value)

  return { localeTag, formatDate, formatDateTime, formatNumber }
}
